// MusicPlayer.tsx
import React, { useState,useRef } from 'react';
import styled, { css } from 'styled-components';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { icons } from './icons'; // your PNG icon imports

////////////////////////////////////////////////////////////////////////////////
// Types
export interface Track { title: string; artist: string; src: string; }

////////////////////////////////////////////////////////////////////////////////
// Static Playlist
const trackList: Track[] = [
  {
    title: 'Minecraft Ambient',
    artist: 'Minecraft',
    src: `${process.env.PUBLIC_URL || ''}/minecraft.mp3`,
  },
  {
    title: '8-Bit Arcade',
    artist: 'Moodmode',
    src: `${process.env.PUBLIC_URL || ''}/8-bit-arcade.mp3`,
  },
  {
    title: 'Arcade Beat',
    artist: 'NCS',
    src: `${process.env.PUBLIC_URL || ''}/arcade-beat.mp3`,
  },
];

////////////////////////////////////////////////////////////////////////////////
// Styled UI
const Wrap = styled.div`display:flex;flex-direction:column;gap:1rem;color:#04abce;`;
const Channel = styled.div`font-size:.75rem;color:#e4ce01;`;
const CustomPlayer = styled(AudioPlayer)`
  background-color: #011748;
  color: #04abce;

  .rhap_time {
    color: #e4ce01;
    font-family: 'ChiKareGo2', monospace;
    font-size: 0.75rem;
  }

  .rhap_current-time,
  .rhap_total-time {
    color: #e4ce01;
  }
    .rhap_progress-filled{
    background: #782c85ff;
    }
    .rhap_progress-indicator{
    background: #782c85ff;
    }
`;

////////////////////////////////////////////////////////////////////////////////
// Component
export default function MusicPlayer({ channelName = 'Nostalgia :)' }) {
  const [idx, setIdx] = useState(0);
  const audioRef = useRef<any>(null); // holds reference to the <audio> element
  const track = trackList[idx];

  const next = () => setIdx(i => (i + 1) % trackList.length);
  const prev = () => setIdx(i => (i - 1 + trackList.length) % trackList.length);
  const pick = (i: number) => setIdx(i);

const handleLoadedMetadata = () => {
  // Logic for initial seek removed to ensure playback starts reliably
};
  return (
    <Wrap>
      <Channel>Channel: {channelName}...</Channel>

      <CustomPlayer
        ref={audioRef}
        src={track.src}
        onEnded={next}
        onClickNext={next}
        onClickPrevious={prev}
        onLoadedMetaData={handleLoadedMetadata}
        showSkipControls
        showJumpControls={false}
        customAdditionalControls={[]}
        customVolumeControls={[]}
        customIcons={{
          play: <img src={icons.playIcon} alt="play" style={{ width: '1.5rem',filter: 'brightness(0) saturate(100%) invert(79%) sepia(86%) saturate(484%) hue-rotate(1deg) brightness(107%) contrast(103%)',}} />,
          pause: <img src={icons.pauseIcon} alt="pause" style={{ width: '1.5rem',filter: 'brightness(0) saturate(100%) invert(79%) sepia(86%) saturate(484%) hue-rotate(1deg) brightness(107%) contrast(103%)' }} />,
          next: <img src={icons.nextIcon} alt="next" style={{ width: '1.5rem',filter: 'brightness(0) saturate(100%) invert(79%) sepia(86%) saturate(484%) hue-rotate(1deg) brightness(107%) contrast(103%)' }} />,
          previous: <img src={icons.prevIcon} alt="prev" style={{ width: '1.5rem',filter: 'brightness(0) saturate(100%) invert(79%) sepia(86%) saturate(484%) hue-rotate(1deg) brightness(107%) contrast(103%)' }} />,
        }}
        autoPlayAfterSrcChange
        autoPlay
        header={`${track.title} — ${track.artist}`}
      />
    </Wrap>
  );
}